import { useAtom } from "jotai";

import { alertAtom } from "./alertAtom";

export const useAlert = () => {
	const [alertId, setAlert] = useAtom(alertAtom);

	const cancel = () => setAlert(null);
	const open = (id: string) => () => setAlert(id);

	return {
		alertId,
		onCancel: cancel,
		onClose: cancel,
		onOpen: open,
	};
};
